import React, { useEffect, useState } from "react";
import "./CardTabs.scss";
import { useSelector } from "react-redux";
import { activateCard, getCardList, deactivateCard, unassignPhysicalCard, updateLostDamagedCardStatus, updateMastercardStatus, getPIExternalInfo4, straightPayment, getPIExternalInfo8 } from "../../util/API/cardservices";
import { Box, Typography } from "@mui/material";
import { TableHead, TableBody, Table, TableContainer, TableCell, TableRow, Pagination, Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import CardDetailsModal from "./CardDetailsModal";
import AddNewCardModal from "./AddNewCardModal";
import { getExternalAccounts } from "../../util/API/externalaccounts";
import { getMastercardDetails } from "../../util/API/transfer";
import PreAuthPaymentModal from "./PreAuthPaymentModal";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import PinPad from "../PinPad/PinPad";

function CardTabs() {
  //test card 45532111111112222260
  const [cards, setCards] = useState([]); //list of user cards
  const [selectedCard, setSelectedCard] = useState(""); //id of the selected card
  const [selectedCardNo, setSelectedCardNo] = useState(""); //card no of the selected card
  const [selectedHiddenCardNo, setSelectedHiddenCardNo] = useState(""); //card no of the selected card
  const [cardOption, setCardOption] = useState("activate");
  const [cardDetails, setCardDetails] = useState({
    status: '',
    active: '',
    cardnumber: '',
    hiddencardnumber: '',
    type: '',
    userpi: '',
    assignedon: "",
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: ''
  })
  const [alertPreAuth, setAlertPreAuth] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: ''
  })
  const [isLoading, setIsLoading] = useState(false);
  const [tablePages, setTablePages] = useState(0);
  const [openModal, setOpenModal] = useState({
    details: false,
    new: false
  });
  const [mastercards, setMastercards] = useState([]);
  const [rejectedCards, setRejectedCards] = useState([])
  const [openPreAuthModal, setOpenPreAuthModal] = useState(false);
  const [selectedCompleteCardNo, setSelectedCompleteCardNo] = useState("");
  const [selectedRowData, setSelectedRowData] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  
  let configVariables = useSelector((state) => state.config.baseConfig);
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");

  // console.log("isSuperAdmin------------",isSuperAdmin);

  const statusMap = {
    "-1": "Blocked",
    "1": "Deleted",
    "2": "Assigned - Not Active",
    "3": "Lost",
    "4": "Damaged",
  };

  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  const handlePreAuthCloseModal = () => {
    setOpenPreAuthModal(false);
  }

  const handleCloseModal = () => {
    setOpenModal({
      ...openModal,
      details: false
    });
    setCardDetails({
      status: '',
      active: '',
      cardnumber: '',
      hiddencardnumber: '',
      type: '',
      userpi: '',
      assignedon: "",
    });
  }

  const currentUser = useSelector(
    (state) => state.usersList.selectedUser
  );

  async function getUserCards() {
    setIsLoading(true)
    const response = await getCardList(currentUser.User.id);
    if (response?.callStatus !== "1" || !response?.payload?.record) {
      setCards([]);
      setIsLoading(false)
      return;
    }
    // let cards = response?.payload?.record;
      // Handle both v2 (payload.record) and v4 (payload.payload)
  let cards = response?.payload?.record ?? response?.payload?.payload;

    // console.log("Cards--------------",response);
    if (!Array.isArray(cards)) {
      cards = [cards];
    }
    setCards(cards);
    setRejectedCards(response?.rejectedCards)
    setIsLoading(false)
  }

  async function getMastercards() {
    let response = await getExternalAccounts(currentUser.User.id);
    // console.log(response)
    let records = response.payload?.record;
    if (!records) return;
    if (!Array.isArray(records)) {
      records = [records];
    }

    // Separate transaction accounts from other accounts
    const mastercardAccounts = records.filter(
      (account) =>
        account.Vuserpi3?.piid === configVariables.reveMasterCard || account.Vuserpi3?.piid === configVariables.reveMSwipeMasterCard
    );

    setMastercards(mastercardAccounts);
  }

  useEffect(() => {
    getUserCards();
    getMastercards()
  }, [openModal.new]);


  useEffect(() => {
    setCardOption(cardDetails?.status == "3" ? "lost" : cardDetails?.status == "4" ? "damaged" : cardDetails?.status == "14" ? "block" : "na")
  }, [cardDetails])

  const handleCardOption = (event) => {
    setCardOption(event.target.value);
  }

  const submitCardOption = async () => {
    console.log("submitCardOption-----------",cardOption);
    let response = null;
    if (!selectedCard || !cardOption) return;
    switch (cardOption) {
      case "activate":
        response = await activateCard(selectedCard, currentUser.User.id);
        setCardDetails((prevDetails) => ({
          ...cardDetails,
          active: 1,
          status: 2,
        }));
        break;
      case "deactivate":
        response = await deactivateCard(selectedCard, currentUser.User.id);
        setCardDetails((prevDetails) => ({
          ...prevDetails,
          active: 0,
        }));
        break;
      case "unassign":
        response = await unassignPhysicalCard(selectedCard, currentUser.User.id);
        setSelectedCard(null);
        break;
      case "lost":
        response = await updateLostDamagedCardStatus(selectedCard, currentUser.User.id, 3, selectedCardNo);
        setCardDetails((prevDetails) => ({
          ...cardDetails,
          active: 0,
          status: 3,
        }));
        break;
      case "damaged":
        response = await updateLostDamagedCardStatus(selectedCard, currentUser.User.id, 4, selectedCardNo);
        setCardDetails((prevDetails) => ({
          ...cardDetails,
          active: 0,
          status: 4,
        }));
        break;
        case "block":
          response = await updateMastercardStatus(
            agent['User'].id,
            cardDetails.userpi,
            currentUser.User.firstName,
            currentUser.User.lastName,
            currentUser.User.address1,
            currentUser.User.address2,
            currentUser.User.cityname,
            currentUser.User.stateid,
            currentUser.User.countryid,
            currentUser.User.zip,
            14
          );
          setCardDetails((prevDetails) => ({
            ...cardDetails,
            active: 0,
            status: 14,
          }));
          break;
        case "unblock":
          response = await updateMastercardStatus(
            agent['User'].id,
            cardDetails.userpi,
            currentUser.User.firstName,
            currentUser.User.lastName,
            currentUser.User.address1,
            currentUser.User.address2,
            currentUser.User.cityname,
            currentUser.User.stateid,
            currentUser.User.countryid,
            currentUser.User.zip,
            4
          );
          setCardDetails((prevDetails) => ({
            ...cardDetails,
            active: 0,
            status: 4,
          }));
          break;
        case "cancel":
          response = await updateMastercardStatus(
            agent['User'].id,
            cardDetails.userpi,
            currentUser.User.firstName,
            currentUser.User.lastName,
            currentUser.User.address1,
            currentUser.User.address2,
            currentUser.User.cityname,
            currentUser.User.stateid,
            currentUser.User.countryid,
            currentUser.User.zip,
            10
          );          
          setCardDetails((prevDetails) => ({
            ...cardDetails,
            active: 0,
            status: 10,
          }));
          break;
      default:
        break;
    }
    // console.log(response)
    if (response?.callStatus === "1" || response?.callStatus === "2") {
      setAlert({
        header: 'Congratulations',
        message: 'Card updated successfully',
        severity: 'success',
        showAlert: true
      });
    } else {
      setAlert({
        header: 'Error',
        message: 'Failed to update card',
        severity: 'error',
        showAlert: true
      });
    }
    getUserCards();
    getMastercards();
    return response;
  }

  const handleManage = (row) => {
    setCardDetails({
      ...cardDetails,
      active: row?.globaluserextref?.active,
      status: row?.physicalcards?.status,
      cardnumber: row?.physicalcards?.cardnumber !== -1 ? row?.physicalcards?.cardnumber : row?.physicalcards?.cardnoclear,
      type: "Plata Card",
      hiddencardnumber: row?.physicalcards?.cardnoclear,
      userpi: '',
      rejected: row?.physicalcards?.status === "2" && rejectedCards?.includes(row?.physicalcards?.cardnumber),
      assignedon: row?.physicalcards?.creationdate
    })
    setSelectedCard(row?.physicalcards?.cardid)
    setSelectedCardNo(row?.physicalcards?.cardnumber)
    setOpenModal({
      ...openModal,
      details: true
    });
  }

  const handleManageMC = async(row) => {
    // console.log(row)
    const response = await getMastercardDetails(
      row.Vuserpi3.id,
      currentUser.User.id,
      row.Vuserpi3.currcode
    ).then((response) => {
      if (response.Status === "1") {
        setCardDetails({
          active: row.Vuserpi3.status,
          // status:  response.payload?.forConsumer?.data?.cardStatusId,
          status: row.Vuserpi3.status,
          cardnumber: response.payload?.forConsumer?.cardnumber,
          hiddencardnumber: row?.Vuserpi3?.cardno,
          type: "Mastercard",
          userpi: response?.payload?.userpi?.id,
          assignedon: row?.Vuserpi3?.addeddatetime
        })
        setSelectedCard(row.Vuserpi3.id)
        setOpenModal({
          ...openModal,
          details: true
        });
      } else if(response?.payload?.callStatus == "0") {
        setAlert({
          header: 'Error',
          message: response?.payload?.msg,
          severity: 'error',
          showAlert: true
        });
      }
    })
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(0,0,0, .1)',
      color: theme.palette.common.black,
      fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: '600'
    },
  }));

  const handleConfirm = (event, pin) => {
    let PIN = pin.join("");
    handleSubmit(event, PIN)
  };

  const handlePreAuthPayment = async(rowData) => {
    try {
      setIsLoading(true);
      // Calling getPIExternalInfo4 to get the complete card no. for sending it to straightPayment
      // const cardResponse = await getPIExternalInfo4("", rowData?.Vuserpi3?.userid, rowData?.Vuserpi3?.id, "", "0", rowData?.Vuserpi3?.currcode);
      const cardResponse = await getPIExternalInfo8("", rowData?.Vuserpi3?.userid, rowData?.Vuserpi3?.id, "", "0", rowData?.Vuserpi3?.currcode);
      if(cardResponse?.data?.header?.callStatus == "1") {
        // console.log("cardResponse============",cardResponse?.data?.body);
        const cardNo = cardResponse?.data?.body?.forConsumer?.cardnumber;
        setSelectedCompleteCardNo(cardNo);
        setSelectedHiddenCardNo(rowData?.Vuserpi3?.cardno);
        setSelectedRowData(rowData);
        setOpenPreAuthModal(true);

        // Call straightPayment api call
        // const response = await

      } else if(cardResponse?.Status == "2") {
        setSelectedCompleteCardNo("");
        setAlert({
          header: 'Error',
          message: 'Failed to get card details.',
          severity: 'error',
          showAlert: true
        });
      }
    } catch (error) {
      setSelectedCompleteCardNo("");
    } finally {
      setIsLoading(false);
    }
  }

  const handleSubmit = async(event, PIN) => {
    // console.log("handleSubmit------------",PIN);
    // console.log("handleSubmit------------",submittedData);
    // console.log("handleSubmit------------",selectedCompleteCardNo);
    // console.log("handleSubmit------------",selectedRowData?.Vuserpi3);
    // console.log("agentID------------",agent["User"].id);

    if(submittedData?.accountentrycomment?.length > 90) {
      setShowPinPad(false);
      setAlertPreAuth({
        header: 'Error',
        message: "Comment should not exceed 90 character length",
        severity: 'error',
        showAlert: true
      });
      return;
    }

    try {
      setIsLoading(true);
      const response = await straightPayment(
        selectedCompleteCardNo, 
        selectedRowData?.Vuserpi3?.currcode, 
        submittedData?.amount, 
        "0", 
        "", 
        submittedData?.accountentrycomment ? submittedData?.accountentrycomment : "", 
        submittedData?.externalrefid ? submittedData?.externalrefid : "", 
        submittedData?.atmaddress ? submittedData?.atmaddress : "",
        PIN,
        agent["User"].id
      );

      if(response?.Status == '1') {
        setShowPinPad(false);
        setOpenPreAuthModal(false);
        setAlert({
          header: 'Congratulations',
          message: 'Pre Auth Payment Done',
          severity: 'success',
          showAlert: true
        });
        
      } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
        setShowPinPad(false);
        setAlertPreAuth({
          header: 'Error',
          message: response?.payload?.msg,
          severity: 'error',
          showAlert: true
        });
      } else if(response?.Status == '0' && response?.["4payresponse"]?.header?.callStatus === "0") {
        setShowPinPad(false);
        setAlertPreAuth({
          header: 'Error',
          message: response?.["4payresponse"]?.header?.msg,
          severity: 'error',
          showAlert: true
        });
      }
      // console.log("handleSubmit_response===============",response);
    } catch (error) {
      console.log("handleSubmit_error=================",error);
    } finally {
      setIsLoading(false);
    }
  }

  const displayPinPad = (data) => {
    // console.log("dataaaaaaaaa------------",data);
    setSubmittedData(data);
    setShowPinPad(true);
  }

  return (
    <div className="loan-tab-container">
      <CardDetailsModal 
        open={openModal.details} 
        cardOption={cardOption}
        handleCardOption={handleCardOption}
        cardDetails={cardDetails}
        handleClose={handleCloseModal} 
        submitCardOption={submitCardOption}
      />

    <AddNewCardModal
      open={openModal.new}
      handleClose={() => { setOpenModal({ ...openModal, new: false }) }}
      cards={cards}
      mastercards={mastercards}
    />

    <PreAuthPaymentModal 
      open={openPreAuthModal}
      handleClose={handlePreAuthCloseModal}
      handleSubmit={displayPinPad}
      alertPreAuth={alertPreAuth}
      setAlertPreAuth={setAlertPreAuth}
      selectedHiddenCardNo={selectedHiddenCardNo}
      // handleSubmit={handleSubmit}
    />

      <header>
      <Box 
        sx={{
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          padding: '0 16px',
          marginBottom: '16px',
        }}
      >
        <Typography variant="h5" sx={{ fontStyle: "Nunito" }}>Card Assignment</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => { setOpenModal({ ...openModal, new: true }) }}
        >
          Add Card +
        </Button>
      </Box>
        <div className="loan-details-table">
          {isLoading && <div className="text-center mt-5">
            <span className="loader" />
          </div>}
          {!isLoading &&
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Card Number</StyledTableCell>
                    <StyledTableCell>Card Type</StyledTableCell>
                    <StyledTableCell>Added On</StyledTableCell>
                    <StyledTableCell>Active</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cards && cards.map((row, index) => (
                    <TableRow key={row.loan_id}>
                      <TableCell align="left" className="">
                        <div>
                          {row?.physicalcards?.cardnoclear}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <div>
                          {(() => {
                            const cardNumber =
                              row?.physicalcards?.cardnumber !== -1
                                ? row?.physicalcards?.cardnumber
                                : row?.physicalcards?.cardnoclear;

                            if (cardNumber.startsWith("4")) {
                              return "Rêve Platacard";
                            } else if (cardNumber.startsWith("5")) {
                              return "Rêve Mastercard";
                            } else {
                              return cardNumber;
                            }
                          })()}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        {row?.physicalcards?.assignmentdate}
                        {/* {row?.physicalcards?.creationdate} */}
                      </TableCell>

                      <TableCell align="left" className="">
                        <div>
                          {row.globaluserextref.active === "1" ? "Active" : "Inactive"}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <div>
                          {row?.globaluserextref?.active === "1" ? "Assigned" : 
                            row?.physicalcards?.status === "2" && !rejectedCards?.includes(row?.physicalcards?.cardnumber) ? "Assigned - Not Active" : 
                            row?.physicalcards?.status === "2" && rejectedCards?.includes(row?.physicalcards?.cardnumber) ? "Rejected" :
                            row?.physicalcards?.status === "3" ? "Lost" : 
                            "Damaged"
                          }
                        </div>
                      </TableCell>
                      <TableCell align="left" className="d-flex gap-1">
                        <Button 
                          variant="contained"
                          onClick={() => handleManage(row)}
                          style={{ marginRight: "10px !important" }}
                        >
                          Manage
                        </Button>

                        {/* <Button 
                          variant="contained"
                          // onClick={() => handleManage(row)}
                        >
                          Post Adjustment
                        </Button> */}
                      </TableCell>
                    </TableRow>
                  ))}

                  {mastercards && mastercards.map((row, index) => (
                    <TableRow key={row.acctID}>
                      <TableCell align="left" className="">
                        <div>
                          {row?.Vuserpi3?.cardno}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <div>
                          {(() => {
                            return "Rêve Mastercard";
                          })()}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        {row?.Vuserpi3?.addeddatetime}
                      </TableCell>
                      <MastercardTableCell row={row} currentUser={currentUser} />
                      <TableCell align="left" className="d-flex gap-1">
                        <Button 
                           variant="contained"
                           onClick={() => handleManageMC(row)}
                        >
                          Manage
                        </Button>

                        {isSuperAdmin == "true" && row.Vuserpi3.status !== "2" && row.Vuserpi3.status !== "1" && <Button 
                          variant="contained"
                          onClick={() => handlePreAuthPayment(row)}
                        >
                          Pre Auth Payment
                        </Button>}
                      </TableCell>
                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
          }
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
            <Pagination
              count={tablePages}
              color="primary"
              // onChange={(event, page) => handlePageChange(page)}
              showFirstButton 
              showLastButton
            />
          </Box>

        </div>
      </header>

      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handleConfirm}
          onClick={() => setShowPinPad(false)}
          loading={isLoading}
        />
      )}

      <CustomAlert
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prevDetails) => {
          setAlert({...prevDetails, showAlert: false});
        }}
        autoclose={alert.severity === "error" ? false : true}
      />
    </div>
  );
}

const MastercardTableCell = ({ row, currentUser }) => {
  const [cardStatus, setCardStatus] = useState("");
  const [cardAssigned, setCardAssigned] = useState("")
  const MCStatusMap = {
    "-1": "Pending for Approval",
    "0" : "Active",
    "1": "Cancelled",
    "2": "Blocked",
  };

  useEffect(() => {
    const fetchCardStatus = async () => {
      try {
        const response = await getMastercardDetails(
          row.Vuserpi3.id,
          currentUser.User.id,
          row.Vuserpi3.currcode
        );
        setCardStatus(
          response.payload?.forConsumer?.data?.cardStatusId
        );
        setCardAssigned("Assigned");
      } catch (error) {
        console.error("Error fetching card status:", error);
        setCardStatus("Error");
      }
    };

    fetchCardStatus();
  }, [row.Vuserpi3.id, currentUser.User.id, row.Vuserpi3.currcode]);

  return (
    <>
      <TableCell align="left" className="">
        <div>{cardStatus === "4" ? "Active" : cardStatus === "14" ? "Blocked" : MCStatusMap[row.Vuserpi3.status] }</div>
      </TableCell>

      <TableCell align="left" className="">
        <div>{cardAssigned}</div>
      </TableCell>
    </>
  );
};

export default CardTabs;
